module.exports = __webpack_public_path__ + "static/media/jobpostimg.77c11d81.webp";